var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoBidQuoteStatusIcon = function SvgNoBidQuoteStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FC5A5A",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5A5A",
    stroke: "#FC5A5A",
    strokeWidth: 0.3,
    d: "m27 27.155-2.137-2.137a.58.58 0 0 0-.4-.168h-.001a.61.61 0 0 0-.612.611v.006a.56.56 0 0 0 .17.383L26.168 28l-2.15 2.126a.56.56 0 0 0-.169.414v-.002zm0 0 2.126-2.126a.6.6 0 0 1 .186-.13L27 27.154Zm2.875 3.102a.42.42 0 0 1 .125.281.46.46 0 0 1-.462.462l.006.15h-.003a.57.57 0 0 1-.428-.17L27 28.846l-2.13 2.13L27.83 28l-.107.106 2.151 2.15Zm0 0 .106-.107h-.001zM30 25.46h.15v-.002l-.15.003Zm0 0a.42.42 0 0 1-.125.305L29.538 25a.46.46 0 0 1 .462.462Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC5A5A",
    fillRule: "evenodd",
    d: "M18 20a4 4 0 0 1 4-4h8.343a4 4 0 0 1 2.829 1.172l1.656 1.656A4 4 0 0 1 36 21.657V34a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4zm16 3v11a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2h7v2a3 3 0 0 0 3 3zm-.11-2a2 2 0 0 0-.476-.757l-1.657-1.657A2 2 0 0 0 31 18.11V20a1 1 0 0 0 1 1z",
    clipRule: "evenodd"
  })));
};
export { SvgNoBidQuoteStatusIcon as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/QuoteStatus/assets/no-bid-quote-status-icon.e30c61bfb4d107c9ec8f00e3c6525e9d.svg";